import React from 'react';
import './StyleComponents/HomeCredit.css';

const HomeCredit = () => {
    return (
        <section className="CreditWrapper" id='movie'>
            <h1 className="CreditHeader">Best Life ✧</h1>

            <div className="MovieContainer">
                <video
                    className="MovieVideo"
                    src="/movie.mp4"  /* change path */
                    controls
                />
            </div>
        </section>
    );
};

export default HomeCredit;
